!(function () {
  "use strict";
  (!(function (t) {
    if (window.jQuery) t(window.jQuery);
    else {
      var attempts = 0;
      var e = setInterval(function () {
        attempts += 1;
        if (window.jQuery) {
          clearInterval(e);
          t(window.jQuery);
        } else if (attempts >= 100) {
          /* Si el CDN falla, no dejamos un intervalo vivo indefinidamente. */
          clearInterval(e);
        }
      }, 50);
    }
  })(function (t) {
    t(document).ready(function () {
      (t("#MobileNavTrigger").off("click.expo click"),
        t(".mobile-nav__sublist-trigger").off("click"),
        t("#MobileNav .mobile-nav__sublist").each(function () {
          var e = t(this);
          "block" === e.css("display") ||
          (e.attr("style") && -1 !== e.attr("style").indexOf("display"))
            ? (e.removeAttr("style"), e.addClass("nm-sublist-open"))
            : e.removeAttr("style");
        }),
        t("#MobileNav").on(
          "click",
          ".mobile-nav__sublist-trigger",
          function (e) {
            e.preventDefault();
            var s = t(this),
              i = s.nextAll(".mobile-nav__sublist").first();
            i.length || (i = s.next("ul"));
            var n = !i.hasClass("nm-sublist-open");
            (i.toggleClass("nm-sublist-open", n),
              s
                .toggleClass("is-active", n)
                .attr("aria-expanded", n ? "true" : "false"));
          },
        ));
    });
  }),
    document.addEventListener(
      "touchstart",
      function (t) {
        var e = t.target.closest(
          ".nm-card-shell, .product-card, .grid-link, #AddToCart, .btn",
        );
        e && e.classList.add("nm-is-pressed");
      },
      { passive: !0 },
    ),
    document.addEventListener(
      "touchend",
      function (t) {
        var e = t.target.closest(
          ".nm-card-shell, .product-card, .grid-link, #AddToCart, .btn",
        );
        e &&
          setTimeout(function () {
            e.classList.remove("nm-is-pressed");
          }, 160);
      },
      { passive: !0 },
    ),
    document.addEventListener(
      "touchcancel",
      function () {
        document.querySelectorAll(".nm-is-pressed").forEach(function (element) {
          element.classList.remove("nm-is-pressed");
        });
      },
      { passive: !0 },
    ));
})();
